// // 📁 src/utils/formHelpers.ts

// 📁 src/utils/formHelpers.ts

import type { ResponseInForm } from '../types/formTypeStructure';

// Breakpoints alignés avec Tailwind CSS
export const BREAKPOINTS = {
  'xs': 0,        // Extra small devices (moins de 640px)
  'sm': 640,      // Small devices (640px et plus)
  'md': 768,      // Medium devices (768px et plus) - équivalent à tablet
  'tablet': 768,  // Alias pour tablet (même valeur que md)
  'lg': 1024,     // Large devices (1024px et plus) - équivalent à laptop
  'laptop': 1024, // Alias pour laptop (même valeur que lg)
  'xl': 1280,     // Extra large devices (1280px et plus)
  '2xl': 1536,    // 2X Large devices (1536px et plus)
  'desktop': 1920, // Desktop screens
  '4k-screen': 2560, // 4K screens
};

export const useResponsiveSize = () => {
  const calculateSize = (screenWidth: number) => {
    let width: number;
    let height: number;

    // Adaptation des tailles aux nouveaux breakpoints
    if (screenWidth < BREAKPOINTS.sm) width = 280;          // xs: mobile très petit
    else if (screenWidth < BREAKPOINTS.md) width = 320;     // sm: mobile standard
    else if (screenWidth < BREAKPOINTS.lg) width = 340;     // md/tablet: tablet
    else if (screenWidth < BREAKPOINTS.xl) width = 360;     // lg/laptop: laptop
    else if (screenWidth < BREAKPOINTS['2xl']) width = 400; // xl: grand laptop
    else if (screenWidth < BREAKPOINTS.desktop) width = 440; // 2xl: écran large
    else if (screenWidth < BREAKPOINTS['4k-screen']) width = 480; // desktop
    else width = 520; // 4k-screen et plus

    // Calcul de la hauteur proportionnelle
    const heightMobileXs = 35;
    const heightKScreen = 65;
    const heightSlope =
      (heightKScreen - heightMobileXs) /
      (BREAKPOINTS['4k-screen'] - BREAKPOINTS.xs);

    height = heightSlope * (screenWidth - BREAKPOINTS.xs) + heightMobileXs;
    height = Math.max(heightMobileXs, Math.min(heightKScreen, height));

    const radiusRatio = 0.25;
    const borderRadius = Math.round(height * radiusRatio);
    const finalBorderRadius = Math.max(8, Math.min(16, borderRadius));

    return {
      width: Math.round(width),
      height: Math.round(height),
      borderRadius: finalBorderRadius,
    };
  };

  return {
    calculateSize
  };
};

export const useCurrentBreakpoint = () => {
  const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1024;

  // Retourne le breakpoint actuel selon les standards Tailwind
  if (screenWidth < BREAKPOINTS.sm) return 'xs';
  else if (screenWidth < BREAKPOINTS.md) return 'sm';
  else if (screenWidth < BREAKPOINTS.lg) return 'md'; // tablet
  else if (screenWidth < BREAKPOINTS.xl) return 'lg'; // laptop
  else if (screenWidth < BREAKPOINTS['2xl']) return 'xl';
  else if (screenWidth < BREAKPOINTS.desktop) return '2xl';
  else if (screenWidth < BREAKPOINTS['4k-screen']) return 'desktop';
  else return '4k-screen';
};

// Fonction helper pour vérifier si on est sur mobile
export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < BREAKPOINTS.md; // < 768px
};

// Fonction helper pour vérifier si on est sur tablet
export const isTablet = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= BREAKPOINTS.md && window.innerWidth < BREAKPOINTS.lg;
};

// Fonction helper pour vérifier si on est sur desktop
export const isDesktop = (): boolean => {
  if (typeof window === 'undefined') return true;
  return window.innerWidth >= BREAKPOINTS.lg;
};

export const getLocalizedText = (
  text: string | { [lang: string]: string } | undefined,
  currentLang: string = 'fr'
): string => {
  if (!text) return '';
  if (typeof text === 'string') return text;
  return (
    text[currentLang] ||
    text['fr'] ||
    text['en'] ||
    Object.values(text)[0] ||
    ''
  );
};

export const getCurrentValue = (
  responses: ResponseInForm | ResponseInForm[]
): any => {
  if (Array.isArray(responses)) return responses.map((r) => r.responseValue);
  return responses.responseValue;
};


















































// import type { ResponseInForm } from '../types/formTypeStructure';

// export const BREAKPOINTS = {
//   'mobile-s': 320,
//   'mobile-m': 375,
//   'mobile-l': 425,
//   tablet: 768,
//   laptop: 1024,
//   'laptop-l': 1440,
//   desktop: 1920,
//   '4k-screen': 2560,
// };

// export const useResponsiveSize = () => {
//   const calculateSize = (screenWidth: number) => {
//     let width: number;
//     let height: number;

//     if (screenWidth <= BREAKPOINTS['mobile-s']) width = 250;
//     else if (screenWidth <= BREAKPOINTS['mobile-m']) width = 310;
//     else if (screenWidth <= BREAKPOINTS['mobile-l']) width = 330;
//     else if (screenWidth <= BREAKPOINTS.tablet) width = 300;
//     else if (screenWidth <= BREAKPOINTS.laptop) width = 300;
//     else if (screenWidth <= BREAKPOINTS['laptop-l']) width = 380;
//     else if (screenWidth <= BREAKPOINTS.desktop) width = 420;
//     else if (screenWidth <= BREAKPOINTS['4k-screen']) width = 420;
//     else width = 500;

//     const heightMobileS = 35;
//     const heightKScreen = 65;
//     const heightSlope =
//       (heightKScreen - heightMobileS) /
//       (BREAKPOINTS['4k-screen'] - BREAKPOINTS['mobile-s']);

//     height = heightSlope * (screenWidth - BREAKPOINTS['mobile-s']) + heightMobileS;
//     height = Math.max(heightMobileS, Math.min(heightKScreen, height));

//     const radiusRatio = 0.25;
//     const borderRadius = Math.round(height * radiusRatio);
//     const finalBorderRadius = Math.max(8, Math.min(16, borderRadius));

//     return {
//       width: Math.round(width),
//       height: Math.round(height),
//       borderRadius: finalBorderRadius,
//     };
//   };

//   return {
//     calculateSize
//   };
// };

// export const useCurrentBreakpoint = () => {
//   const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1024;

//   if (screenWidth < BREAKPOINTS['mobile-s']) return 'xs';
//   else if (screenWidth < BREAKPOINTS['mobile-m']) return 'mobile-s';
//   else if (screenWidth < BREAKPOINTS['mobile-l']) return 'mobile-m';
//   else if (screenWidth < BREAKPOINTS.tablet) return 'mobile-l';
//   else if (screenWidth < BREAKPOINTS.laptop) return 'tablet';
//   else if (screenWidth < BREAKPOINTS['laptop-l']) return 'laptop';
//   else if (screenWidth < BREAKPOINTS.desktop) return 'laptop-l';
//   else if (screenWidth < BREAKPOINTS['4k-screen']) return 'desktop';
//   else return '4k-screen';
// };

// export const getLocalizedText = (
//   text: string | { [lang: string]: string } | undefined,
//   currentLang: string = 'fr'
// ): string => {
//   if (!text) return '';
//   if (typeof text === 'string') return text;
//   return (
//     text[currentLang] ||
//     text['fr'] ||
//     text['en'] ||
//     Object.values(text)[0] ||
//     ''
//   );
// };

// export const getCurrentValue = (
//   responses: ResponseInForm | ResponseInForm[]
// ): any => {
//   if (Array.isArray(responses)) return responses.map((r) => r.responseValue);
//   return responses.responseValue;
// };
